<template lang="html">

  <div
    :title="percentageLabel"
    :class="[!total ? 'is-plain' : '']"
    class="progress">

    <div
      class="progress-container"
      :style="{'width': size + 'px', 'height': size + 'px'}">


      <svg
        version="1.1"
        preserveAspectRatio="xMinYMin"
        :viewBox="viewBoxString">
        <circle
          class="progress-meter"
          :cx="radius"
          :cy="radius"
          :r="(radius)"
          fill="none"
          stroke="lightgrey"
          stroke-dashoffset="100"
          :style="{'stroke-width': widthStroke}" />
        <circle
          class="progress-value"
          :cx="radius"
          :cy="radius"
          :r="(radius)"
          fill="none"
          :stroke="colorHexa"
          :style="{
            'stroke-dashoffset': circumference,
            'stroke-dasharray': circleDashOffset,
            'stroke-width': widthStroke,
            'transform': 'translate(' + size + ' ' + size + ')'}"/>
      </svg>

      <div class="progress-content">
        <p class="progress-value">{{displayValue}}</p>
        <p class="progress-label">{{unit}}</p>
      </div>

      <!-- <div :class="pickColor" class="progress-content">
        <p  class="progress-value">{{value}}</p>
        <p :class="{'is-gray-400': !is_sla}" class="progress-label">{{unit}}</p>
      </div> -->

    </div>

    <p class="progress-title">{{label}}</p>

  </div>

</template>

<script lang="js">

export default {
  name: 'ProgressStandalone',
  components: {
    //
  },
  props: {
    value: {
      type: [String, Number],
    },
    unit: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    total: {
      type: [String, Number],
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    gradient: {
      type: String,
      required: false,
    },
    size: {
      type: Number,
      required: false,
      default: 105,
    },
    widthStroke: {
      type: Number,
      required: false,
      default: 10,
    },
    // is_sla: {
    //   type: Boolean,
    //   default: false
    // }
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true;
    }, 0);
  },
  data() {
    return {
      isMounted: false,
      colors: {
        default: 'alpha',
        alpha: '#133D8D',
        beta: '#B4C5E7',
        gamma: '#F58025',
        delta: '#44E0CE',
        epsilon: '#3399CC',
        danger: '#FF5959',
      },
    };
  },
  methods: {

  },
  computed: {
    colorHexa() {
      return this.colors[(this.colors[this.color]) ? this.color : this.colors.default];
    },
    // pickColor() {
    //   if (this.is_sla) {
    //     return `is-${this.color}`
    //   }
    // },
    percentage() {
      return parseInt(this.value * 100 / this.total, 10);
    },
    percentageLabel() {
      if (!this.total) {
        return '';
      }
      return `${this.value}/${this.total}${this.unit} (${this.percentage}%)`;
    },
    radius() {
      return this.size / 2;
    },
    viewBoxString() {
      return `0 0 ${this.size} ${this.size}`;
    },
    circumference() {
      return 2 * Math.PI * this.size / 2;
    },
    circleDashOffset() {
      const value = this.circumference / 100 * this.percentage + this.circumference;
      return this.isMounted ? value : this.circumference;
    },

    displayValue() {
      return Math.round(this.value * 100) / 100;
    },
  },
};
</script>
